import React, {useEffect, useState} from "react";

export type SchemaData = {
    schemaType?: string,
    optionType: 'dynamic' | 'static';
    jsonSchema?: string;
    title?: string;
    metadescription?: string;
    publishedDate?: string;
    modifiedDate?: string;
    metatitle?: string
  };
  type SchemaProps = {
    data: SchemaData
  }
 const  SeoSchema = (props: SchemaProps) => {
  console.log(' Seo Schema---data', props);
  const {data} = props;
  const {schemaType = 'Article', optionType = 'dynamic', jsonSchema, title, metadescription, publishedDate, modifiedDate, metatitle} = data;
  const [isError, setIsError] = useState(false)

  const generateSchemaData = () => {
    let schemaData = null;
    // "seoTitle": metatitle,

    switch (schemaType) {

      case 'Article':
        schemaData = {
            "@context": "https://schema.org",
            "@type": "Article",
            "mainEntityOfPage": { 
              "@type": "WebPage",
              "@id": `${window.location.href}#mainEntityOfPage`
            },
            "headline": title, 
            "name":metatitle,
            "description": metadescription,
            "datePublished": publishedDate, 
            "dateModified": modifiedDate 
          };
        break;
      default:
        console.warn(`Unsupported schema type: ${schemaType}`);
        break;
    }

    return schemaData;
  };


  useEffect(() => {
    let schemaData = null;
    if(optionType && optionType === 'dynamic') {
        setIsError(false);
        schemaData = generateSchemaData();
    } else if(optionType === 'static' && jsonSchema) {
        try {
           setIsError(false);
           schemaData = JSON.parse(jsonSchema)
        } catch (error) {
            setIsError(true);
            console.log('Not a valid jason')
        }
    }

    if (!schemaData) {
      return;
    }

    const jsonLdScript = document.createElement('script');
    jsonLdScript.type = 'application/ld+json';
    jsonLdScript.textContent = JSON.stringify(schemaData);

    document.head.appendChild(jsonLdScript);

    return () => {
      // Cleanup function to remove the added script when the  unmounts
      document.head.removeChild(jsonLdScript);
    };
  }, [schemaType, jsonSchema, optionType]);

  return <>
    {isError ? <h3> Not a valid JSON</h3> : null}
  </>;
 };
 
 export default  SeoSchema;